var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('EditablePage',{attrs:{"content":_vm.content,"config":_vm.config,"templateDefinitions":_vm.templateDefinitions}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }